import { useMutation } from "@apollo/client";
import { DOCUMENT_DELETE } from "graphql/mutation/document-gql";
import { successNotification } from "components/request-result";
import notifyMutationError from "components/request-result/notify-mutation-error";
import { useTranslation } from "components/use-hooks";

const useMutationDocumentDelete = (id) => {
  const translations = useTranslation();
  const failedMessage = translations["APP_SETTINGS.Error_InvalidResponse"];
  const [mutate, { loading, client }] = useMutation(DOCUMENT_DELETE);

  const _setMutationDocumentDelete = async (options) => {
    try {
      const result = await mutate(options);
      const payload = result.data?.documentDelete;
      if (!payload) {
        throw new Error(failedMessage);
      }
      client.cache.evict({ id: client.cache.identify({ __typename: "Document", id }) });
      client.cache.gc();
      successNotification({ title: payload.label, description: payload.message });
      return id;
    } catch (error) {
      notifyMutationError(error);
      throw error;
    }
  };

  return {
    _setMutationDocumentDelete,
    loadingMutationDocumentDelete: loading,
  };
};

export default useMutationDocumentDelete;
